import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import * as faceapi from 'face-api.js';
import { Subscription, timer } from 'rxjs';
import { takeWhile } from 'rxjs/operators';
import { ConfirmComponent } from '../confirm/confirm.component';
import { CbtService } from '../services/cbt.service';
import { CompanyDetailsService } from '../services/company-details.service';
import { FeedbackService } from "../services/feedback.service";
import { LoaderService } from "../services/loader.service";
import { LogService } from '../services/log.service';
import { UserService } from '../services/user.service';

// declare const faceapi: any;
@Component({
  selector: 'app-cbt',
  encapsulation: ViewEncapsulation.None,
  templateUrl: './cbt.component.html',
  styleUrls: ['./cbt.component.css']
})
export class CbtComponent implements OnInit {

  p_system = localStorage['p_system'];
  public examDetails = null;
  public examSections: any = [];
  public CBTForm: FormGroup;
  public questionsSimplified = [];
  public displayPrevious = false;
  public displayNext = true;
  public examToBeTaken = null;
  public displayTime;
  public totalTimeLeft;
  public loading = false;
  public malPracticeMessage = '';
  public malPracticeCount = 0;
  public percentageOffense = 0;
  public company;
  public student;
  currentTime = this.getDateObj();
  timeInterval: NodeJS.Timeout
  private timerSubscription: Subscription;
  public offenseIncreaseRate = 0;
  public activeSectionIndex = 0;
  public activeSectionQuestions = [];
  public activeQuestionIndex = 0;
  public optionsLabel = { 0: 'A', 1: 'B', 2: 'C', 3: 'D', 4: 'E' }
  public options = [
    { key: 'option_a' },
    { key: 'option_b' },
    { key: 'option_c' },
    { key: 'option_d' },
    { key: 'option_e' }
  ];
  public noFaceCount = 0;
  public offence_check = "";
  public exam_mode = "";
  public r_id = "";
  public offence_image: any = "";
  public camera_check = 0;
  public screen_check = 0;
  public offence_track_id = "";
  public offence_limit = 0;
  public cameraCheckInterval: NodeJS.Timeout;
  public auto_submit_onLimit = 0;
  // public offenseIncreaseRate = 25;
  public tryThis = "<font size='4'>Is this possible <input type='text' style='border: none; border-bottom: 2px solid black; outline: none;'> ___</font>";
  @ViewChild('video') video;
  @ViewChild('image') image;
  constructor(
    private _companyDetailsService: CompanyDetailsService,
    private _userService: UserService,
    private _cbtService: CbtService,
    private fb: FormBuilder,
    private _loaderService: LoaderService,
    private _feedbackService: FeedbackService,
    private router: Router,
    public log: LogService,
    private dialog?: MatDialog
  ) {

    this.examToBeTaken = this._cbtService.examTobeTaken;
    if (this.examToBeTaken == null) {
      // console.log('unauthorized access');
      this.router.navigate(['/home/dashboard']);
      return;
    }

    this.navigateFromScreen = this.navigateFromScreen.bind(this);

    this._cbtService.examModeDetails.subscribe(data => {
      // console.log(data);
      this.offence_limit = data.offence_limit;
      if (data.screen_check == 1) {
        document.addEventListener('visibilitychange', this.navigateFromScreen);
      }
    })

    //redirect if exam has been taken before
    this._cbtService.isSubmitted().subscribe(data => {
      if (data?.submitted) {
        this.router.navigate(['/home/dashboard']);
        // console.log("exam already taken");
        return;
      }
    })
    // console.log('exam_to_be_taken: ', this.examToBeTaken);

    this._cbtService.examModeDetails.subscribe(data => {
      if (data.exam_mode == "1" && data.camera_check == 1) {
        Promise.all([
          faceapi.nets.tinyFaceDetector.loadFromUri('assets/models'),
          faceapi.nets.faceLandmark68Net.loadFromUri('assets/models'),
          faceapi.nets.faceRecognitionNet.loadFromUri('assets/models'),
          faceapi.nets.faceExpressionNet.loadFromUri('assets/models'),
          faceapi.nets.ssdMobilenetv1.loadFromUri('assets/models'),
        ]).then(() => this.startVideo());
      }
    })

  }


  @ViewChild('radio', { static: true }) radio;


  ngOnInit() {
    this.countDown();

    this.log
      .addLog({
        action: "Access",
        component: "CBT",
        details: `Accessed CBT`,
      }).subscribe(data => { });

    this._loaderService.changeEmitted$.subscribe(data => {
      this.loading = data.loader;
    })

    this._companyDetailsService.getDetails().subscribe(data => {
      this.company = {
        logo: data.logo,
        name: data.name,
        subdomain: data.adm_initial
      }
    })
    this._userService.getUserData().subscribe(data => {
      this.student = {
        gender: data.gender,
        student_id: data.student_id,
        name: data.lastname + " " + data.firstname,
        passport: data.passport,
        matric_no: data.matric_no,
      };
    })

    this.getExamDetails();
    // this.getExamQuestions();
    // console.log(this.r_id, this.screen_check, this.camera_check);

    this.timeInterval = setInterval(() => {
      this.currentTime = this.getDateObj();
    }, 1000);
    // console.log(this.offence_limit, "jajdaj")
  }

  ngOnDestroy() {
    clearInterval(this.timeInterval)
    this.timerSubscription?.unsubscribe();
    if (this.cameraCheckInterval) {
      clearInterval(this.cameraCheckInterval);
    }
    // document.removeEventListener('visibilitychange', () => this.navigateFromScreen());
  }

  navigateFromScreen() {
    if (document.visibilityState === 'hidden') {
      this.increaseOffense("Navigated away from test screen");
    }
  }

  removeEvent() {
    document.removeEventListener('visibilitychange', this.navigateFromScreen);
    if (this.cameraCheckInterval) {
      clearInterval(this.cameraCheckInterval);
    }
  }


  getOffenceValue() {
    let value = Math.round((this.malPracticeCount / this.offence_limit) * 100);
    return value >= 100 ? 100 : value;

  }

  increaseOffense(message) {
    this.malPracticeMessage = message;
    this.malPracticeCount++;
    this.keepOffence(this.malPracticeMessage);
    if (this.malPracticeCount >= this.offence_limit && this.auto_submit_onLimit == 1) {
      this.submitExam("offence");
      this.malPracticeMessage = "Your offense meter is full"
      // alert("Offence meter Full");
      // this._Router.navigate(['/logout']);
    }
  }

  // startVideo() { //START VIDEO
  //   if (!this.video && !this.video.nativeElement) return
  //   let video = this.video.nativeElement;
  //   // console.log(video, this.video, this.video.nativeElement);
  //   if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
  //     navigator.mediaDevices.getUserMedia({ video: true }).then((stream) => {
  //       video.srcObject = stream;
  //       video.addEventListener('play', async () => {
  //         const canvas = await faceapi.createCanvasFromMedia(video);
  //         canvas.classList.add("hidden");
  //         document.body.append(canvas);
  //         const displaySize = { width: video.width, height: video.height }
  //         faceapi.matchDimensions(canvas, displaySize);

  //         this.cameraCheckInterval = setInterval(async () => {
  //           const detections = await faceapi.detectAllFaces(video, new faceapi.TinyFaceDetectorOptions()).withFaceLandmarks().withFaceExpressions()
  //           // console.log('detection: ', detections);
  //           if (detections.length > 0) {
  //             this.noFaceCount = 0;
  //             // this.increaseOffense("Face not detected");
  //             // this.malPracticeMessage = "Face not detected";
  //           } else {
  //             this.noFaceCount += 1;
  //             canvas.classList.add("hidden");
  //             if (this.noFaceCount >= 40) {
  //               this.increaseOffense("No face detected");
  //               this.malPracticeMessage = "No face detected";
  //               this.noFaceCount = 0;
  //             }
  //           }
  //           // console.log(this.noFaceCount, "facecount");
  //           if (detections.length > 1) {
  //             const canvas = document.createElement('canvas');
  //             canvas.width = video.videoWidth;
  //             canvas.height = video.videoHeight;
  //             canvas.classList.add("hidden");
  //             canvas.getContext('2d').drawImage(video, 0, 0);

  //             const img = document.createElement("img");
  //             img.src = canvas.toDataURL('image/webp');
  //             this.offence_image = img.src;
  //             // console.log(this.offence_image);

  //             this.increaseOffense("Multiple faces detected");
  //             this.malPracticeMessage = "Multiple faces detected";
  //             // let form = new FormData();
  //             // form.append("img", canvas.toDataURL('image/webp'));
  //             // this.auth.saveImage(form).subscribe(data => {})
  //           } else {
  //             // this.malPracticeMessage = "";
  //           }

  //           const resizedDetections = faceapi.resizeResults(detections, displaySize)
  //           canvas.classList.add("hidden");
  //           canvas.getContext('2d').clearRect(0, 0, canvas.width, canvas.height)

  //           //THIS PART DRAWS LANDMARKS AND EXPRESSION ON FACES IN THE VIDEO
  //           // faceapi.draw.drawDetections(canvas, resizedDetections)
  //           // faceapi.draw.drawFaceLandmarks(canvas, resizedDetections)
  //           // faceapi.draw.drawFaceExpressions(canvas, resizedDetections)
  //         }, 2000)
  //       })

  //     });
  //   }
  // }
  startVideo() {
    const videoElement = this.video?.nativeElement;
    if (!videoElement || !navigator.mediaDevices?.getUserMedia) return;

    navigator.mediaDevices.getUserMedia({ video: true }).then(stream => {
      videoElement.srcObject = stream;
      videoElement.addEventListener('play', async () => {
        const canvas = faceapi.createCanvasFromMedia(videoElement);
        document.body.append(canvas);
        const displaySize = { width: videoElement.width, height: videoElement.height };
        faceapi.matchDimensions(canvas, displaySize);

        this.cameraCheckInterval = setInterval(async () => {
          const detections = await faceapi
            .detectAllFaces(videoElement, new faceapi.TinyFaceDetectorOptions())
            .withFaceLandmarks()
            .withFaceExpressions();

          this.handleDetections(detections, canvas, displaySize);
        }, 2000);
      });
    });
  }

  stopCamera() {
    navigator.mediaDevices.getUserMedia({ video: true })
      .then((stream) => {
        stream.getTracks().forEach(track => track.stop());
      })
      .catch(error => console.error("Error stopping camera:", error));
  }

  stopFaceAPI() {
    faceapi.nets.tinyFaceDetector.dispose();
    faceapi.nets.faceLandmark68Net.dispose();
    faceapi.nets.faceRecognitionNet.dispose();
    faceapi.nets.faceExpressionNet.dispose();
  }


  handleDetections(detections: any[], canvas: HTMLCanvasElement, displaySize: any) {
    if (detections.length === 0) {
      this.noFaceCount++;
      if (this.noFaceCount >= 40) {
        this.increaseOffense("No face detected");
        this.noFaceCount = 0;
      }
    } else {
      this.noFaceCount = 0;
    }

    if (detections.length > 1) {
      this.captureOffenseImage();
      this.increaseOffense("Multiple faces detected");
    }

    const resizedDetections = faceapi.resizeResults(detections, displaySize);
    canvas.getContext('2d').clearRect(0, 0, canvas.width, canvas.height);
  }

  captureOffenseImage() {
    const videoElement = this.video?.nativeElement;
    const canvas = document.createElement('canvas');
    canvas.width = videoElement.videoWidth;
    canvas.height = videoElement.videoHeight;
    canvas.getContext('2d').drawImage(videoElement, 0, 0);
    this.offence_image = canvas.toDataURL('image/webp');
  }




  countDown() {
    this._cbtService.examInitialSummary({ request: 'get_exam_summary', exam_id: this.examToBeTaken.exam_id }).subscribe(data => {
      this.malPracticeCount = data.offence_count;
      this.offence_track_id = data.offence_track_id;
      this.offence_limit = data.offence_limit;
      this.auto_submit_onLimit = data.auto_submit_onlimit;
      // if (data.offence_track_id != null) {
      // }
      let counterEnd = Math.floor(data.time_left) || Math.floor(data.duration);
      this.startCountDown(counterEnd);

      if (this.offence_track_id && data.camera_sound_check == 1) {
        this._cbtService.examStudentImage.subscribe(image => {
          if (image != "no-image") {
            let obj = { offence_track_id: this.offence_track_id, image }
            this._cbtService.keepStudentVirtualExamImage(obj).subscribe(data => {
              // console.log(data);
              this._cbtService.examStudentImage.next("no-image");
            })
          }
        })
      }
    })

  }

  startCountDown(secondsLeft: number) {
    this.timerSubscription?.unsubscribe();

    if (secondsLeft > 0) {
      this.timerSubscription = timer(0, 1000).pipe(
        takeWhile(() => secondsLeft > 0)
      ).subscribe(() => {
        console.log(`Before: ${secondsLeft} @ ${this.router.url}`);
        secondsLeft--;
        console.log(`After: ${secondsLeft} @ ${this.router.url}`);
        // Calculate remaining time
        let hrs = Math.floor(secondsLeft / 3600);
        let mins = Math.floor((secondsLeft - (hrs * 3600)) / 60);
        let secs = Math.floor(secondsLeft - ((hrs * 3600) + (mins * 60)));
        this.displayTime = String(hrs).padStart(2, '0') + ":" + String(mins).padStart(2, '0') + ":" + String(secs).padStart(2, '0');

        if (secondsLeft <= 0) {
          alert(`Time Left : ${secondsLeft} \nIf time left is more than zero, please call support immediately and share a picture of this`);
          this.submitExam("time");
          secondsLeft = 0;
        }

        this.totalTimeLeft = secondsLeft;

        if (secondsLeft % 60 === 0) {
          this.questionChanged(); // to update time left and save progress
        }
      });
    }

  }

  questionChanged() {
    let answered = 0;
    let batchSubmission = 2;
    if (this.activeQuestionIndex == 0 && this.activeSectionIndex == 0) {
      this.displayPrevious = false;
    } else {
      this.displayPrevious = true
    }

    if (this.activeQuestionIndex === this.activeSectionQuestions.length - 1 && this.activeSectionIndex === this.examSections - 1) {
      this.displayNext = false;
    } else {
      this.displayNext = true;
    }

    //save progress after every five question
    const form = this.CBTForm.value;
    for (let key in form) {
      if (form[key] !== null) {
        answered += 1;
      }
    }

    if (answered % batchSubmission === 0 && answered !== 0) {
      // console.log(this.malPracticeCount);
      let value = Number(((this.malPracticeCount / this.offence_limit) * 100).toFixed(2));
      let offence_value = Math.round(value);
      this._cbtService.saveProgress({
        request: 'save_progress',
        examData: form,
        totalTimeLeft: this.totalTimeLeft,
        offence_count: this.malPracticeCount,
        offence_value: offence_value,
        offence_track_id: this.offence_track_id
      }).subscribe();
    }

    const sectionQuestions = this.examSections[this.activeSectionIndex].questions
    this.examSections[this.activeSectionIndex].questions = sectionQuestions
      .map((each, i) => (i == this.activeQuestionIndex ? ({ ...each, read: true }) : each));
    this.activeSectionQuestions = sectionQuestions;
    // this.sectionChanged(this.activeSectionIndex, this.activeQuestionIndex)
  }

  nextStep() {
    if (this.activeQuestionIndex != this.activeSectionQuestions.length - 1) {
      this.activeQuestionIndex += 1;
      this.sectionChanged(this.activeSectionIndex, this.activeQuestionIndex);
    } else {
      this.sectionChanged(this.activeSectionIndex + 1);
    }
  }

  previousStep() {
    if (this.activeQuestionIndex != 0) {
      this.activeQuestionIndex -= 1;
      this.sectionChanged(this.activeSectionIndex, this.activeQuestionIndex);
    } else {
      this.sectionChanged(this.activeSectionIndex - 1);
    }
  }


  getExamDetails() {
    this._cbtService.cbtAction({ request: "get_exam_details", exam_id: this.examToBeTaken.exam_id }).subscribe(data => {
      this.examDetails = data[0];
      this.exam_mode = this.examDetails.exam_mode;
      this.r_id = this.examDetails.r_id;
      this.camera_check = this.examDetails.camera_sound_check;
      this.screen_check = this.examDetails.screen_tab_check;
      // console.log(this.camera_check, this.screen_check);
      this.getExamQuestions();
    })
  }

  getExamQuestions() {
    // console.log(this.r_id);
    this._loaderService.emitChange(true);
    let controlVar = {};
    this._cbtService.cbtAction({ request: "get_exam_questions", exam_id: this.examToBeTaken.exam_id, r_id: this.r_id }).subscribe(data => {
      // console.log(data);
      this._loaderService.emitChange(false);
      if (data == null) {
        // console.log('could not load questions');
        return
      }
      if (data[0].offence_track_id != null) {
        this.offence_track_id = data[0].offence_track_id;
        if (this.camera_check == 1) {
          this._cbtService.examStudentImage.subscribe(image => {
            if (image != "no_image") {
              let obj = { offence_track_id: this.offence_track_id, image }
              this._cbtService.keepStudentVirtualExamImage(obj).subscribe(data => {
                // console.log(data);
                this._cbtService.examStudentImage.next("no_image");
              })
            }
          })
        }
      }
      this.examSections = data;
      this.examSections.map(es => {
        es.questions.map(q => {
          this.questionsSimplified.push(
            { question_id: q.question_id, chosen_answer: q.chosen_answer }
          );
        })
      })
      for (let x in this.questionsSimplified) {
        controlVar["q" + this.questionsSimplified[x].question_id] = this.questionsSimplified[x].chosen_answer;
      }
      this.CBTForm = this.fb.group(controlVar);
      this.sectionChanged();
    })
  }

  saveExam(examData, reason) {
    const dialogRef = this.dialog.open(ConfirmComponent, {
      data: {
        text: "Are you sure you want to submit?",
        reason
      },
    });

    dialogRef.afterClosed().subscribe(response => {
      if (response === 1) {
        this.submitExam("click");
      }
    })


  }

  submitting = false
  submitExam(reason) {
    this.removeEvent();
    this.stopCamera();
    this.stopFaceAPI();
    sessionStorage.setItem('reason', reason);
    this._loaderService.emitChange(true);
    this.submitting = true;
    let value = Number(((this.malPracticeCount / this.offence_limit) * 100).toFixed(2));
    let offence_value = Math.round(value);
    // setTimeout(() => {
    this._cbtService.submitExam({ request: "submit_exam", examData: this.CBTForm.value, totalTimeLeft: 0, offence_count: this.malPracticeCount, offence_value: offence_value, offence_track_id: this.offence_track_id }).subscribe(data => {
      this._loaderService.emitChange(false);
      this.submitting = false;
      if (data.success) {
        this._cbtService.submitted = true;
        clearInterval(this.timeInterval)
        // data[4] = this.examSections;
        // this._cbtService.emitChange(data);
        this.log
          .addLog({
            action: "Submitted",
            component: "CBT",
            details: `Submitted CBT Exam`,
          }).subscribe(data => { });
        this.router.navigate(['/cbt/exam-summary']);
      } else {
        this._loaderService.emitChange(false);
        this._feedbackService.emitChange("Something went wrong", "failed-color");
      }
    }, _ => {
      this._loaderService.emitChange(false);
      this.submitting = false;
      this._feedbackService.emitChange("Something went wrong. Please try again.", "failed-color");
    })
    // }, 5000);
  }


  getDateObj() {
    const dateObj = new Date();
    return {
      time: dateObj.toLocaleTimeString(),
      year: dateObj.getFullYear(),
      date: dateObj.toLocaleDateString('en-US', { day: '2-digit', month: 'long', year: 'numeric' }),
    };
  }


  sectionChanged(i: number = this.activeSectionIndex, questionIndex = 0, answer = null) {
    if (this.submitting) return;
    if (i < 0 || i >= this.examSections.length) return;
    this.activeSectionIndex = i;
    this.examSections[i].questions = this.examSections[i].questions.map((each, eachI) => ({
      ...each,
      class: this.activeQuestionIndex == eachI ? '' : 'cFade',
      answered: this.CBTForm.value['q' + each.question_id] ? true : false,
      chosen_answer: answer ? answer : each.chosen_answer,
      // answered: this.CBTForm.value['q' + id] ? true : false,
      // current: each.question_id == id ? true : false
    }));
    this.activeSectionQuestions = this.examSections[i].questions
    this.examSections[i] = {
      ...this.examSections[i],
      answered: this.examSections[i].questions.filter(eachQ => eachQ.answered).length,
      // read: this.examSections[i].questions.filter(eachQ => eachQ.answered).length,
    }
    // console.log(this.examSections[i]);

    if (Number(this.examSections[i].questions.length)) {
      // this.activeQuestion = this.activeSectionQuestions[questionIndex];
      this.activeQuestionIndex = questionIndex
    } else {
      this.activeQuestionIndex = 0
    }
    this.questionChanged();
  }


  optionSelected(id) {
    document.getElementById(id).click();
  }


  keepOffence(offence_message) {
    let obj = { offence_message: offence_message, offence_track_id: this.offence_track_id, image: this.offence_image };
    this._cbtService.keepOffence(obj).subscribe(data => {
      if (data.success) {
        this.offence_image = "";
      }
    })
  }

}
